import React from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Label,
} from 'reactstrap';

class EditCampaign extends React.PureComponent {
  render() {
    const {
      validation,
      validations,
      updating,
      values,
      onChange,
    } = this.props;

    return (
      <>
        <td>
          <div className="mb-2">
            <Label for="name" className="font-weight-bold mb-0 me-3">Name</Label>
            <Input
              disabled={updating}
              id="name"
              style={{ width: '90%' }}
              value={values.name}
              onChange={onChange}
              pattern={validation.campaign_name}
              invalid={!validations.name}
            />
          </div>
          <div className="mb-2">
            <Label for="start" className="font-weight-bold mb-0 me-3 text-nowrap">Start Date</Label>
            <Input
              disabled={updating}
              id="start"
              style={{ width: '90%' }}
              value={values.start}
              onChange={onChange}
              pattern={validation.date}
              invalid={!validations.start}
              type="date"
            />
          </div>
          <div className="mb-2">
            <Label for="end" className="font-weight-bold mb-0 me-3 text-nowrap">End Date</Label>
            <Input
              disabled={updating}
              id="end"
              style={{ width: '90%' }}
              value={values.end}
              onChange={onChange}
              pattern={validation.date}
              invalid={!validations.end}
              type="date"
            />
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center mb-1">
            <Input
              disabled={updating}
              id="q_to_shoppers"
              style={{ width: '15%' }}
              value={values.q_to_shoppers}
              onChange={onChange}
              pattern={validation.campaign_number_value}
              invalid={!validations.q_to_shoppers}
            />
            <Label for="q_to_shoppers" className="font-weight-bold mb-0 ms-2 text-nowrap">
              Percentage of Quotes Saved as % of Beneficiaries
            </Label>
          </div>
          <div className="d-flex align-items-center mb-1">
            <Input
              disabled={updating}
              id="es_to_quotes"
              style={{ width: '15%' }}
              value={values.es_to_quotes}
              onChange={onChange}
              pattern={validation.campaign_number_value}
              invalid={!validations.es_to_quotes}
            />
            <Label for="es_to_quotes" className="font-weight-bold mb-0 ms-2 text-nowrap">
              Enrollments Started as % of Quotes Saved
            </Label>
          </div>
          <div className="d-flex align-items-center mb-1">
            <Input
              disabled={updating}
              id="ec_to_enrollments"
              style={{ width: '15%' }}
              value={values.ec_to_enrollments}
              onChange={onChange}
              pattern={validation.campaign_number_value}
              invalid={!validations.ec_to_enrollments}
            />
            <Label for="ec_to_enrollments" className="font-weight-bold mb-0 ms-2 text-nowrap">
              Enrollments Completed as % of Enrollments Started
            </Label>
          </div>
          <div className="d-flex align-items-center mb-1">
            <Input
              disabled={updating}
              id="es_to_shoppers"
              style={{ width: '15%' }}
              value={values.es_to_shoppers}
              onChange={onChange}
              pattern={validation.campaign_number_value}
              invalid={!validations.es_to_shoppers}
            />
            <Label for="es_to_shoppers" className="font-weight-bold mb-0 ms-2 text-nowrap">
              Enrollments Started as % of Beneficiaries
            </Label>
          </div>
          <div className="d-flex align-items-center mb-1">
            <Input
              disabled={updating}
              id="ec_to_shoppers"
              style={{ width: '15%' }}
              value={values.ec_to_shoppers}
              onChange={onChange}
              pattern={validation.campaign_number_value}
              invalid={!validations.ec_to_shoppers}
            />
            <Label for="ec_to_shoppers" className="font-weight-bold mb-0 ms-2 text-nowrap">
              Enrollments Completed as % of Beneficiaries
            </Label>
          </div>
        </td>
      </>
    );
  }
}

export default connect()(EditCampaign);
